import React from 'react'
import { Outlet } from 'react-router'
import SideNav from './SideNav'
import styles from './mainAdmin.module.css'

export default function MainAdmin() {
  return (
    <div className={styles['main-admin']}>
        <SideNav/>
        <Outlet/>
    </div>
  )
}
